import React from "react";
import { X } from "lucide-react";

interface NumericKeypadProps {
  value: string;
  length?: number;
  onChange: (val: string) => void;
}

export const NumericKeypad: React.FC<NumericKeypadProps> = ({ value, length = 4, onChange }) => {
  const handlePress = (num: string) => {
    if (value.length < length) {
      onChange(value + num);
    }
  };

  const handleDelete = () => {
    if (value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const keys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["", "0", "del"]
  ];

  return (
    <div className="w-full max-w-xs mx-auto mt-8 select-none">
      {keys.map((row, i) => (
        <div key={i} className="flex justify-between mb-4">
          {row.map((key, j) => {
            if (key === "") {
              return <div key={j} className="w-16 h-16" />;
            }
            if (key === "del") {
              return (
                <button
                  key={j}
                  type="button"
                  onClick={handleDelete}
                  className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-2xl text-gray-500 active:bg-gray-200 focus:outline-none"
                  aria-label="Borrar"
                >
                  <X className="h-7 w-7" />
                </button>
              );
            }
            return (
              <button
                key={j}
                type="button"
                onClick={() => handlePress(key)}
                className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-2xl font-semibold text-gray-900 active:bg-gray-200 focus:outline-none"
                aria-label={key}
                disabled={value.length >= length}
              >
                {key}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}; 